import { Pipe, PipeTransform } from "@angular/core";

import { StakingService } from "../services/contracts/staking.service";

@Pipe({
  name: 'convertLpToUsd',
})
export class ConvertLpToUsdPipe implements PipeTransform {
  constructor(private stakingService: StakingService) {}

  transform(value: string): string {
    if (value) {
      return (+value * this.stakingService.conversionRate).toString();
    }

    return '0';
  }
}
